import { PlansDetails } from 'components/shop/MobilePlans/typings/plans';

export function doPlansContainMultipleCtas(planCardsProducts: PlansDetails) {
  return planCardsProducts?.some((planCard) => {
    if (planCard.ctaOverrides) {
      return planCard.ctaOverrides.length > 1;
    }
    return false;
  });
}
